export default (item, value) => {
    const dataItems = item.value.toLowerCase();
    const dataValue = value.toLowerCase();

    return dataItems.includes(dataValue);
};
